// extracted by mini-css-extract-plugin
module.exports =  {"container":"container_JaNXgoje","transparent":"transparent_CpOGG7PK","title":"title_JyPeghRv","description":"description_GzU8Ujqj","extraContent":"extraContent_zIrusIKW"};